import { render, staticRenderFns } from "./reportmoduleiframe.vue?vue&type=template&id=1b82e07a&"
import script from "./reportmoduleiframe.vue?vue&type=script&lang=js&"
export * from "./reportmoduleiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports